function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './static-modal-app.scss';
import template from './static-modal-app.html';

export var StaticModalAppComponent = {
  template: template,
  styles: styles,
  bindings: {
    onClick: "&",
    allowClose: "<",
    textContent: "@",
    maintenance: "<" },

  controller: /*#__PURE__*/function () {StaticModalAppComponentController.$inject = ["UserService"];
    function StaticModalAppComponentController(UserService) {
      "ngInject";_classCallCheck(this, StaticModalAppComponentController);
      this.UserService = UserService;
      console.log(this);
    }_createClass(StaticModalAppComponentController, [{ key: "$onInit", value: function $onInit()

      {
        window.amplitude.getInstance().logEvent("App Popup Show");
        var uid = this.UserService.data.uid;
        if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch) {
          this.googleLink = this.appleLink = 'https://gplans.page.link/?link=https://g-plans.com/app/dash/?uid=' + uid + '&apn=com.gplans&ibi=com.g-plans&isi=1287437272&ius=gplansapp';
        } else
        {
          this.googleLink = 'https://play.google.com/store/apps/details?id=com.gplans';
          this.appleLink = 'https://itunes.apple.com/ng/app/g-plans-nutrition/id1287437272';
        }
      } }, { key: "logEvent", value: function logEvent()

      {
        window.amplitude.getInstance().logEvent("App Popup Yes");
      } }]);return StaticModalAppComponentController;}() };